export const ANG_EXTERNAL_QUERY_PARAMS = ['sort', 'view', 'search_id'];

// Search preset section link IDs
export const ALL_ASSETS_LINK_ID = 'all';
export const ALL_ORGANIZATION_LINK_ID = 'all-org';
export const ACTIVE_ORGANIZATION_LINK_ID = 'org';
export const MULESOFT_ORGANIZATION_LINK_ID = 'mulesoft';
export const SHARED_WITH_ME_LINK_ID = 'shared';
